import React, { useEffect, useState } from "react";
import { Button } from "../UI";

const StatusBarPagination = (props) => {
  const { api } = props; // Grid API
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [pageSize, setPageSize] = useState(20); // Track selected page size

  useEffect(() => {
    if (!api) return;

    const updatePagination = () => {
      setCurrentPage(api.paginationGetCurrentPage() + 1);
      setTotalPages(api.paginationGetTotalPages());
      setTotalRows(api.getDisplayedRowCount()); // Get total rows
      props.updateCount(api.getDisplayedRowCount());
    };

    // Listen to pagination changes
    api.addEventListener("paginationChanged", updatePagination);
    updatePagination(); // Initialize

    return () => {
      api.removeEventListener("paginationChanged", updatePagination);
    };
  }, [api]);

  const handlePageSizeChange = (event) => {
    const newSize = Number(event.target.value);
    setPageSize(newSize);
    api.paginationSetPageSize(newSize); // Update AG Grid page size
  };

  const goToFirstPage = () => api.paginationGoToFirstPage();
  const goToPrevPage = () => api.paginationGoToPreviousPage();
  const goToNextPage = () => api.paginationGoToNextPage();
  const goToLastPage = () => api.paginationGoToLastPage();

  return (
    <div className="ag-status-name-value">
      <div>
        <span className="component">Total Records &nbsp;</span>

        <span className="ag-status-name-value-value">{totalRows}</span>
      </div>

      <div className="pagination_custom">
        <span>
          <Button onClick={goToFirstPage} className="pagi">
            <span
              class="ag-icon ag-icon-first"
              unselectable="on"
              role="presentation"
            ></span>
          </Button>
        </span>

        <span>
          <Button onClick={goToPrevPage} className="pagi">
            {" "}
            <span
              class="ag-icon ag-icon-previous"
              unselectable="on"
              role="presentation"
            ></span>
          </Button>{" "}
        </span>
        <span className="lt_pagi">
          Page {currentPage} of {totalPages}
        </span>
        <span>
          <Button onClick={goToNextPage} className="pagi">
            <span
              class="ag-icon ag-icon-next"
              unselectable="on"
              role="presentation"
            ></span>
          </Button>{" "}
        </span>
        <span>
          <Button onClick={goToLastPage} className="pagi">
            <span
              class="ag-icon ag-icon-last"
              unselectable="on"
              role="presentation"
            ></span>
          </Button>
        </span>
      </div>
      <div className="page-size-status__bar">
        <span>Per Page</span> &nbsp;
        <select
          className="form-control"
          onChange={handlePageSizeChange}
          value={pageSize}
        >
          <option value="20">20</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </select>
      </div>
    </div>
  );
};

export default StatusBarPagination;
